const CONTAINER_NAME = {
  ACCOUNT_SWITCHER_FLYOUT: 'account_switcher_flyout',
  ACCOUNT_SWITCHER_MODAL: 'account_switcher_modal',
  ACCOUNT_RECOVERY: 'account_recovery',
  BOARD_INVITE: 'board_invite',
  CLOSEUP: 'closeup',
  CLOSEUP_BANNER: 'closeup_banner',
  FOLLOW_BUTTON: 'followbtn',
  GOOGLE_ONE_TAP: 'google_one_tap_modal',
  LOGIN_PAGE: 'login_page',
  INSPIRED_BANNER: 'inspired_banner',
  MFA_LOGIN_PAGE: 'mfa_login_page',
  HYBRID_CLICKTHROUGH: 'hybrid_clickthrough',
  HYBRID_BANNER: 'hybrid_banner',
  PIN_GRID: 'pin_grid',
  PIN_IMAGE: 'pin_image',
  RESPONSE_FLYOUT: 'response_flyout',
  UNAUTH_BANNER: 'unauth_banner',
  UNAUTH_HEADER: 'unauth_header',
};

export default CONTAINER_NAME;
